/* Ocha & Co. — shared media helpers (oct 2026)
   [data-oc-autoplay] on a <video>: plays muted while on screen, pauses off screen (not with reduced motion).
   [data-oc-yt="VIDEO_ID"] on a button: opens the YouTube film in a lightbox. */
(() => {
  if (window.__ocMedia) return;
  window.__ocMedia = true;

  const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const bind = (root) => {
    const vids = (root || document).querySelectorAll('video[data-oc-autoplay]:not([data-oc-bound])');
    if (!vids.length) return;
    const play = (v) => { v.muted = true; const p = v.play(); if (p && p.catch) p.catch(() => {}); };
    if (reduce) { vids.forEach((v) => { v.dataset.ocBound = '1'; v.removeAttribute('autoplay'); }); return; }
    if (!('IntersectionObserver' in window)) { vids.forEach((v) => { v.dataset.ocBound = '1'; play(v); }); return; }
    const io = new IntersectionObserver((entries) => entries.forEach((e) => {
      if (e.isIntersecting) play(e.target); else e.target.pause();
    }), { threshold: 0.2 });
    vids.forEach((v) => { v.dataset.ocBound = '1'; v.muted = true; io.observe(v); });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => bind()); else bind();
  document.addEventListener('shopify:section:load', (e) => bind(e.target));

  let yt = null;
  const openYt = (id, title, opener) => {
    if (!yt) {
      yt = document.createElement('dialog');
      yt.id = 'oc-yt-dialog';
      yt.innerHTML = '<div class="oc-yt__frame"><button type="button" class="oc-yt__close" aria-label="Close video">×</button><div class="oc-yt__ratio" data-yt-slot></div></div>';
      document.body.appendChild(yt);
      yt.addEventListener('click', (e) => { if (e.target === yt || e.target.closest('.oc-yt__close')) yt.close(); });
      yt.addEventListener('close', () => { yt.querySelector('[data-yt-slot]').innerHTML = ''; if (yt._opener) yt._opener.focus(); });
    }
    yt._opener = opener;
    const f = document.createElement('iframe');
    f.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0&modestbranding=1&playsinline=1';
    f.title = title || 'Video';
    f.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
    f.allowFullscreen = true;
    yt.querySelector('[data-yt-slot]').appendChild(f);
    yt.showModal();
  };
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-oc-yt]');
    if (!b) return;
    e.preventDefault();
    openYt(b.dataset.ocYt, b.dataset.ocYtTitle, b);
  });
})();
